import React from 'react';
import { ChevronDown } from 'lucide-react';
const HERO_IMAGE = 'https://autowallis.si/wp-content/uploads/2026/04/the-1-des-1500x756.jpg';
export function Hero() {
  return <section className="relative w-full overflow-hidden bg-aw-navy-dark" data-id="element-68" data-mp="9kte1nsdw2xr">
      <img src={HERO_IMAGE} alt="BMW serije 1 na obalni cesti" className="absolute inset-0 h-full w-full object-cover" data-id="element-69" data-mp="9ipax82b77yj" />
      <div className="absolute inset-0 bg-gradient-to-r from-black/80 via-black/45 to-transparent" data-id="element-70" data-mp="129qtzk94hnnc" />

      <div className="relative mx-auto flex min-h-[520px] w-full max-w-[1360px] flex-col justify-center px-5 py-24 lg:min-h-[620px] lg:px-10" data-id="element-71" data-mp="xa4ipgcuuhh6">
        <div className="max-w-2xl border-l-2 border-white/70 pl-6" data-id="element-72" data-mp="sde2mt11vlvr">
          <h1 className="font-heading text-3xl font-bold uppercase leading-tight text-white sm:text-4xl lg:text-5xl" data-id="element-73" data-mp="nbexpepnwgwp">
            BMW serije 1 že od 27.900 EUR.
          </h1>
          <p className="mt-4 text-base text-white/80" data-id="element-74" data-mp="381xlmzcsr4ap">
            Možnost financiranja BMW Financial Services s 3,99 % obrestno mero.
          </p>
          <a href="#" className="mt-8 inline-block bg-aw-accent px-7 py-3 text-sm font-semibold text-white transition-colors hover:bg-white hover:text-aw-navy" data-id="element-75" data-mp="3j9afx9oryk3k">
            Več informacij
          </a>
        </div>

        <ul className="mt-12 space-y-3 text-sm uppercase tracking-[0.06em] text-white/60" data-id="element-76" data-mp="3e8whmjcz6oiq">
          <li className="border-l border-white/40 pl-6 transition-colors hover:text-white" data-id="element-77" data-mp="30hhq1o505f02">
            <a href="#" data-id="element-78" data-mp="358hnqvly413m">Opel Grandland</a>
          </li>
          <li className="border-l border-white/40 pl-6 transition-colors hover:text-white" data-id="element-79" data-mp="35a2fyeksf7yb">
            <a href="#" data-id="element-80" data-mp="2qlepuntpnqfr">Privlačni servisni paketi za vozila BMW</a>
          </li>
        </ul>
      </div>

      <div className="relative flex justify-center pb-6 text-white/70" data-id="element-81" data-mp="2vj7uhcfd8cdx">
        <ChevronDown className="h-6 w-6 animate-bounce" aria-hidden="true" data-id="element-82" data-mp="2hk85u4rurxhr" />
      </div>
    </section>;
}